import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import {
  loginVerifyOTP,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import OtpInput from "react18-input-otp";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { useDispatch } from "react-redux";
import { getProfile } from "../../../../redux/profile/action";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
    .required("OTP is required"),
});

export default function VerifyOTP({ setnextPage, valuess }) {
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(30);
  const [canResend, setCanResend] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (!timeLeft) {
      setCanResend(true);
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const initialValues = {
    country_code: valuess?.country_code,
    mobile_number: valuess?.mobile_number,
    otp: "",
  };

  const handleSubmit = (values) => {
    const data = { ...values, otp };
    loginVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem("urexperttoken", res.data.response.token);
          localStorage.setItem("role_type", res.data.response.role_type);
          localStorage.setItem("refresh_token", res.data.response.refresh_token);
          dispatch(getProfile());
          navigate(`/${lan}/account`);
          urtoast("Login Successfully", 1);
          window.location.reload()
        } else if (!res.data.status) {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      });
  };

  const resetotp = () => {
    setTimeLeft(30);
    setCanResend(false);
    const state = initialValues;
    sendOTP(state)
      .then((res) => {
        if (res.data.status) {
          urtoast("OTP sent successfully", 1);
        } else if (!res.data.status) {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      });
  };

  return (
    <div className="mx-auto register email otp-sec">
      <img
        className="mail-img "
        src={`${CloudStorage.cloudurl}/Assets/Images/common/otp.svg`}
        alt=""
      />
      <h1>Verify OTP</h1>
      <p>
        OTP has been sent to the mobile number {valuess?.country_code}
        {valuess?.mobile_number}. <span> Please check your device shortly</span>
      </p>
      <a onClick={() => setnextPage(true)} className="change-number">
        Change Number
      </a>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <div className="col-md-11 mx-auto form-sec">
              <div className="form-group">
                <label htmlFor="otp">OTP</label>
                <OtpInput
                  value={otp}
                  onChange={(otp) => {
                    setOtp(otp);
                    setFieldValue("otp", otp);
                  }}
                  numInputs={6}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  containerStyle="otp-container"
                  inputStyle="otp-input"
                />
                {errors.otp && touched.otp ? (
                  <div className="error">{errors.otp}</div>
                ) : null}
              </div>

              <div className="last-form">
                <button className="btn create-account" type="submit">
                  Verify & Login
                </button>
                <p>
                  Didn’t receive OTP?{" "}
                  <a onClick={resetotp}>
                    {!canResend ? `Resend in ${timeLeft} seconds` : "Resend"}
                  </a>
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
